document.querySelectorAll('[data-swiper-name="featured-collection"]').forEach(function (swiper) {
  // Get slides count from data attributes
  const slidesDesktop = parseInt(swiper.getAttribute('data-slides-desktop')) || 4;
  const slidesMobile = parseInt(swiper.getAttribute('data-slides-mobile')) || 1;

  // Initialize Swiper instance
  const featuredCollectionSwiper = new Swiper(swiper, {
    slidesPerView: slidesMobile,
    spaceBetween: 10,
    speed: 700,
    loop: true,
    navigation: {
      nextEl: '.slider-button--next', 
      prevEl: '.slider-button--prev',
    },
    // Responsive breakpoints
    breakpoints: {
      1024: {
        slidesPerView: slidesDesktop,
        spaceBetween: 15
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 15
      },
    },
  });
});
